module.exports = __webpack_public_path__ + "static/media/dashboard.d43cb369.svg";